import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function ITsolutions() {

  // useEffect(()=>{
  //   document.title = 'Elixir | About Us';
  // }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Our Jobs</span></h1>
                <h4>Join Elixir Advertising: Innovate, Grow, Succeed</h4>
              </div>
            </Col>
            <Col lg={9}>
            <div className="projectPages-box5">                            
              <div className="jobBox">
                <h4>About Our IT Solutions Company</h4>
                <img src={require('../assets/img/itsolution-banner-img-1.jpg')} className="itsolutionBanner" alt="elixir"  />
                <p>Elixir Worldwide is a leading provider of comprehensive IT solutions in Saudi Arabia and the Middle East, delivering innovative technology services to enterprises, organizations, and SMEs. With a focus on quality, reliability, and cutting-edge technology, we empower businesses to achieve digital transformation, operational efficiency, and sustainable growth.</p>
                <p><strong>Our expertise spans a wide range of services, including:</strong></p>
                <h6>1. Software Development & Mobile Applications</h6>
                <p>We design and develop custom software solutions and mobile applications tailored to your business needs. From enterprise systems to intuitive mobile apps, we deliver solutions that enhance productivity, streamline operations, and improve user experiences.</p>
                <h6>2. IT Consultancy & Strategy</h6>
                <p>Our consultancy services help organizations align technology with business objectives, optimize IT infrastructure, and implement innovative solutions that drive measurable results.</p>
                <h6>3. IT Skills Manpower Supply</h6>
                <p>We provide qualified IT professionals across multiple domains, including software development, system administration, networking, and cybersecurity. Our manpower solutions ensure your projects are staffed with experienced, certified, and competent experts.</p>
                <h6>4. Networking & Hardware Installations</h6>
                <p>From network design and deployment to hardware installation and maintenance, we provide end-to-end infrastructure solutions that guarantee secure, efficient, and scalable IT environments.</p>
                <h6>5. Managed IT Services & Support</h6>
                <p>Our team delivers ongoing IT support and managed services, ensuring your systems run smoothly, securely, and without downtime.</p>
                <h6>Our Commitment in the Middle East</h6>
                <p>Operating across Saudi Arabia and the GCC, we combine global IT expertise with local market understanding, delivering technology solutions that meet regional standards, compliance, and business requirements. We focus on innovation, timely delivery, and exceptional customer service, making us a trusted partner for businesses seeking end-to-end IT capabilities.</p>

                <Row className="visionText">
                  <Col lg={6}>
                    <div className="visionText-box">
                      <h5>Vision</h5>
                      <p>To be the most trusted and innovative IT solutions partner in the Middle East, enabling organizations to leverage technology for sustainable growth.</p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="visionText-box">
                      <h5>Mission</h5>
                      <p>To provide cutting-edge IT solutions, skilled manpower, and consultancy services that empower clients to achieve digital excellence, operational efficiency, and measurable business outcomes.</p>
                    </div>
                  </Col>
                </Row>  
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default ITsolutions;
